import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentLibraryConstants } from '../document-library-constants';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DocumentService } from '../services/document.service';
import { DocumentCommentDTO } from '../models/document-comment/documentCommentDTO';
import { DocumentPersistenceService } from '../services/document-persistence.service';
import { DocumentDetail } from '../models/documentVersionDetail';

@Component({
  selector: 'app-document-comment-creation-slider',
  templateUrl: './document-comment-creation-slider.component.html',
  styleUrls: ['./document-comment-creation-slider.component.scss']
})
export class DocumentCommentCreationSliderComponent implements OnInit{

@Input() isSliderOpen : boolean = false;
@Input() documentNumber!:string;
@Input() documentVersion!:any;
@Output() isSliderActive = new EventEmitter<boolean>();
@Output() reloadDocumentComments = new EventEmitter<boolean>();
sliderHeaderText : string = DocumentLibraryConstants.DocumentCommentCreationSliderHeader;
errorMessages: any = [];
errorHeading: string = DocumentLibraryConstants.DocumentComment_ErrorText;
commentText : string = ''
documentCommentDto !: DocumentCommentDTO
documentDetail!: DocumentDetail

constructor(private confirmationService : ConfirmationService, 
  private documentService : DocumentService,
  private messageService : MessageService,
private documentPersistenceService : DocumentPersistenceService) {
  
}
  ngOnInit(): void {
  }

  closeSlider(){
    this.confirmationService.confirm({
      header: DocumentLibraryConstants.Document_Slider_Confirmation_Header,
      message: DocumentLibraryConstants.Document_Slider_Confirmation_Text,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.isSliderOpen = false;
        this.commentText = '';
        this.reloadDocumentComments.emit(false);
        this.isSliderActive.emit(this.isSliderOpen);
      },
      reject: () => {},
    });
  }
  saveDocumentComment(){
    this.errorMessages = []
    this.validateCommentText();
    if(this.errorMessages.length == 0){
      this.documentCommentDto = {
        documentNumber : this.documentNumber,
        documentVersion : this.documentVersion.toString(),
        commentText : this.commentText
      }
      this.documentService.createDocumentCommand(this.documentCommentDto).subscribe({
        next:()=>{
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Success,
            summary: DocumentLibraryConstants.DocumentComment_CreationSuccessMessage,
          })
          setTimeout(() => {   
            this.isSliderOpen = false;
            this.commentText = '';
            this.reloadDocumentComments.emit(true);
            this.isSliderActive.emit(this.isSliderOpen);
            this.reloadDocumentDetails();          
          }, 1000);          
        }
      })
    }
  }

  async reloadDocumentDetails(){
      await new Promise(resolve => setTimeout(resolve, 3000));
      this.documentService.getDocumentDetailByVersion(this.documentNumber, this.documentVersion).subscribe({
        next: (documentDetailServiceData) => {
          this.documentDetail = documentDetailServiceData;
          this.documentPersistenceService.updateDocumentComments(this.documentDetail.documentComments!);
        }
      })
  }

  validateCommentText(){
    if(this.commentText == '' || this.commentText == null){
      this.errorMessages.push(DocumentLibraryConstants.DocumentCommentText_ErrorMessage);
    }
  }

}
